import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"; // Import pour la navigation interne
import "./Widget.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

const Widget = ({ type }) => {
  const [amount, setAmount] = useState(0);
  const [diff, setDiff] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (type === "user") {
          const usersCollection = collection(db, "users");
          const userSnapshot = await getDocs(usersCollection);
          setAmount(userSnapshot.size);
        } else if (type === "order") {
          const ordersCollection = collection(db, "orders");
          const orderSnapshot = await getDocs(ordersCollection);
          setAmount(orderSnapshot.size);
        } else if (type === "earning") {
          const productsCollection = collection(db, "products");
          const productSnapshot = await getDocs(productsCollection);
          setAmount(productSnapshot.size);
        } else if (type === "balance") {
          const paymentsCollection = collection(db, "payments");
          const paymentSnapshot = await getDocs(paymentsCollection);
          const totalGeneral = paymentSnapshot.docs.reduce(
            (sum, doc) => sum + parseFloat(doc.data().totalPrice || 0),
            0
          );
          setAmount(totalGeneral);
          setDiff(10); // Exemple d'une différence statique
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données :", error);
      }
    };

    fetchData();
  }, [type]);

  let data;

  switch (type) {
    case "user":
      data = {
        title: "UTILISATEURS",
        isMoney: false,
        link: "/admin/users",
        icon: (
          <PersonOutlineOutlinedIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "order":
      data = {
        title: "COMMANDES",
        isMoney: false,
        link: "/admin/orders",
        icon: (
          <ShoppingCartOutlinedIcon
            className="icon"
            style={{
              color: "goldenrod",
              backgroundColor: "rgba(218, 165, 32, 0.2)",
            }}
          />
        ),
      };
      break;
    case "earning":
      data = {
        title: "PRODUITS",
        isMoney: false,
        link: "/admin/products",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
            }}
          />
        ),
      };
      break;
    case "balance":
      data = {
        title: "TRANSACTIONS",
        isMoney: true,
        link: "/admin",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{
              color: "purple",
              backgroundColor: "rgba(128, 0, 128, 0.2)",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "TND"} {amount}
        </span>
        <Link to={data.link} className="link">
          Voir plus de Détails
        </Link>
      </div>
      <div className="right">
        <div className={`percentage ${diff >= 0 ? "positive" : "negative"}`}>
          <KeyboardArrowUpIcon />
          {diff}%
        </div>
        {data.icon}
      </div>
    </div>
  );
};

export default Widget;
